module.exports = __webpack_public_path__ + "files/farizon-vilsans.79ad898558a41f2b25074fe6cbc56c38.pdf";